import { RouterModule, Routes } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { AuthComponent } from './layout/auth/auth.component';
import { AuthGuardFxn } from './core/guards/auth.guard';
import { RouteVerificationComponent } from './open links/route-verification/route-verification.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'auth/login',
    pathMatch: 'full'
  },
  {
    path: 'auth',
    canActivate: [AuthGuardFxn],
    component: AuthComponent,
    loadChildren: () => import('./pages/auth/auth-route').then(m => m.routes)
  },
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuardFxn],
    children: [
      {
        path: '',
        loadChildren: () => import('./pages/after-login-page/pages-route').then((m) => m.routes)
      }
    ]
  },
  {
    path: 'noTenant',
    component: RouteVerificationComponent
  }
];

RouterModule.forRoot(routes, {
  scrollPositionRestoration: 'enabled'
});
